// Base

// Base: Layout

window.breakpoint = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1560,
  hd: 1920,
};

window.sh_height = {
  mb: 60,
  dt: 88,
};
